var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.shit$("mxh:calc(100% - 90px - 46px); fixed; overflow:a; right:30px; bottom:30px; z:999; dis:f; flex-d:c-r;")},_vm._l((_vm.notifyInstance),function(o){return _c('T-notify',{key:o.id,attrs:{"data":o}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }